<template>
  <div id="homepage">

        
    <div v-if="page.type == 'content'" class="text_page">  
        <div class="content" v-html="page.content"></div>
    </div>

    <div id="press_page" v-if="page.type == 'pdf'" style="text-align:center;">
      <iframe :src="page.embed_pdf_path" frameborder="0" style="max-width: 90%; margin:0 auto;margin-top:3%"></iframe>
  </div>

    <div v-if="page.type == 'youtube'" class="video_page"  style="text-align:center;">  
        <iframe :src="'https://www.youtube.com/embed/' + page.youtube_code + '?enablejsapi=1&amp;autoplay=1'" style="max-width: 90%; margin:0 auto;margin-top:3%" frameborder="0" allow="encrypted-media" allowfullscreen="" id="youtubeiframeid"></iframe>
    </div>
    <div id="press_page" v-if="page.iframe" style="text-align:center;">
     <iframe class="iframe_webpage" :src="page.iframe" style="max-width: 90%; margin:0 auto;" ></iframe>
</div>

  </div>
</template>

<script>
export default {
  props: ["widgets", "item"],
  
  data() {
    return {
      id: this.$route.params.mid,
    }
  },
  computed: {
      page(){
          for (let i in this.item.menu)
          {
              if (this.item.menu[i].id == this.id)
              {
                  let item = this.item.menu[i];
                  if (item.content != '') { item.type = 'content'; }
                  else if (item.embed_pdf != '' && item.embed_pdf != null) { item.type = 'pdf'; }
                  else if (item.iframe != '') { item.type = 'iframe'; }
                  else if (item.youtube_code != '') { item.type = 'youtube'; }
                  else if (item.url != '') { item.type = 'url'; }
                  return item;
              }
          }
          return [];
      }
  },
  created(){
    
    //console.log(this.page);
    
  }
}
</script>
